const TOKEN_KEY = "azimi_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Pure permission check against a user's effective_permissions map.
export function can(user, module, action) {
  if (!user) return false;
  if (user.is_owner) return true;
  const perms = user.effective_permissions || {};
  return Array.isArray(perms[module]) && perms[module].includes(action);
}
